import React, { Component } from 'react';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { LenderRow } from '../components/LenderRow';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(r?:string): void;
    applicant?: number;
    lvemploymenttype?: string;
    updateLead(props: any): void;
    consent: boolean; 
    applicationType: string;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    lvemploymenttype?: string;
    partnerSmoker?: boolean;

}

export class LVEmploymentType extends Component<IProps, IState> {
    
    constructor (props: IProps) {
        super(props);
        this.state = {
            hasError: false, 
            lvemploymenttype: this.props.lvemploymenttype,            
        };
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    CaptureEmploymentType(option:string){
        this.setState({lvemploymenttype:option, hasError:false});
        this.props.updateLead({lvemploymenttype:option});
        this.nextStep(option);
    }

    nextStep(lvemploymenttype: string) {
    const errors: string[] = [];   
    

    if(!lvemploymenttype){
        errors.push('Please select a response ?');        
    }

    if (errors.length > 0) {
        this.setState({ hasError: true, errors });
        return;
    }

    // if(lvemploymenttype){
    //     if(this.props.applicant === 1) 
    //         this.props.updateLead({lvemploymenttype: lvemploymenttype}); 
    //     else
    //         this.props.updateLead({partnerSmoker: lvemploymenttype}); 
    //         //this.props.nextStep()
    // }

    this.props.updateLead({lvemploymenttype: lvemploymenttype});  
    this.setState({ hasError: false, errors: [] });
    this.props.nextStep(lvemploymenttype)
    }

    render() {

        const{lvemploymenttype,hasError,errors}=this.state;

        return (
            <header className="App-header">
                <div className='wrapper'>
                    <h1 className='l'>Employment Type{(this.props.applicationType === 'joint' && this.props.applicant === 2)?' your partner':''}</h1>
                    {/* <h1 className='l'>{this.props.applicant === 1 ? '' : 'your partner'}</h1> */}
                    <h2 className='l'> <br />What is your employment  <span className='doddltext'>type?</span></h2>
                    <div className='row'>
                        <div className='column2 justify-e'>
                            <div className={`boxty small ${lvemploymenttype === 'paye' ? 'selected' : ''}`}onClick={() => {this.CaptureEmploymentType('paye')}}>
                                <div>
                                    <div><h2 className='btn'>PAYE</h2></div>
                                </div>
                            </div>
                        </div>
                        <div className='column2 justify-s'>
                            <div className={`boxty small ${lvemploymenttype === 'selfemployed' ? 'selected' : ''}`} onClick={() => {this.CaptureEmploymentType('selfemployed')}}>
                                <div>
                                    <div><h2 className='btn'>Self Employed</h2></div>
                                </div>
                            </div>
                        </div>
                    </div>



                    {hasError &&
                        <ErrorBox errors={errors!} />
                    }

                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            {/* <NextButton customLabel={(this.props.applicationType === 'single' && this.props.applicant === 1) || (this.props.applicationType === 'joint' && this.props.applicant === 2)?'Finish':'Next'} onClick={() => this.nextStep(lvemploymenttype)} /> */}
                            {/* <NextButton customLabel='Next' onClick={() => this.nextStep(lvemploymenttype)} /> */}
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>
                </div>
            </header>
        );
    }
}